export * from './bericht-delete-request.interface';
export * from './bericht-delete-response.interface';
export * from './bericht-delete.shapes';
